class WPPopups{

    constructor(){
        this.ajaxUrl = window.WPShopify.ajax_url;
        this.el = this.createRoot('WPPopups', 'popups-root');
        this.$el = jQuery(this.el);
        this.popups={};
        this.requestPopupsData();
        this.attachRoot();
        this.initEvents();
    }

    createRoot(id, className){
        const el = document.createElement('div');
        el.id = id;
        el.classList.add(className);
        return el;
    }

    attachRoot(){
        document.body.appendChild(this.el);
    }

    initEvents(){
        this.$el.on('click','.close-btn', this.handleClosePopup.bind(this) );
    }

    handleClosePopup(event){
        const btnEl = event.currentTarget;
        const popupId = btnEl.getAttribute('data-target');
        const popupItem = this.popups[popupId];

        if(popupItem){
            if( popupItem.$el){

                const rememberCloseTimeDays = popupItem.remember_closed_time || 30; // default fallback

                popupItem.$el.modal('hide');

                // set cookies to remember close.
                const expire = new Date();
                expire.setDate( expire.getDate() + rememberCloseTimeDays );

                this.setCookie(popupId, 1, {
                    path: '/',
                    expires: expire
                });


            }
        }
    }

    requestPopupsData(){

        return jQuery.ajax({
            method:'GET',
            url: this.ajaxUrl,
            context: this,
            data:{
                action: 'load_popups'
            }

        }).done((response)=>{
            console.log('Popups',response);
            if ( response.data && Array.isArray(response.data) ){

                response.data.forEach(this.instantiatePopup.bind(this));

            }

        });
    }

    instantiatePopup(item){

        if(item.enable){

            // check if user has cookie or not!
            if( ! this.getCookie(item.name) ){

                const timeout = parseInt(item.show_timeout) || 0;

                setTimeout(()=>{

                    this.$el.append(this.renderPopup(item));

                    item.$el = jQuery(`#wppopup-${item.name}`);

                    item.$el.modal();

                    this.popups[item.name] = item;


                }, timeout);

            }

        }
    }

    renderPopup(data){
        let iframeCode = '';
        if(data.iframe_page){
            iframeCode = `<iframe src="${data.iframe_page}"></iframe>`
        }
        // TODO make updates to ajax urls.
        return `
<div class="modal fade" id="wppopup-${data.name}">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
        <div class="wppopup__wrapper">
            <div class="wppopup__image" style="background-image: url('${data.image}')"></div>
            <div class="wppopup__content-col">
                <div class="wppopup__content">
                    ${data.content}
                    ${iframeCode}
                </div>
                <div class="wppopup__content-bottom">${data.bottom_content}</div>
            </div>
            <button class="close-btn" data-target="${data.name}" aria-label="Close Popup"></button>
        </div>
    </div>
   </div>
</div>
`;

    }

    getCookie(name) {
        const matches = document.cookie.match(new RegExp(
            '(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1') + '=([^;]*)'
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    setCookie(name, value, options) {
        options = options || {};

        let expires = options.expires;

        if (typeof expires == 'number' && expires) {
            let d = new Date();
            d.setTime(d.getTime() + expires * 1000);
            expires = options.expires = d;
        }
        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString();
        }

        value = encodeURIComponent(value);

        let updatedCookie = name + '=' + value;

        for (let propName in options) {
            updatedCookie += '; ' + propName;
            let propValue = options[propName];
            if (propValue !== true) {
                updatedCookie += '=' + propValue;
            }
        }

        document.cookie = updatedCookie;
    }

    static  initialize(){
        WPShopify.Shop.WPPopups = new WPPopups();
    }

}

jQuery(document).ready(()=>{

    if(jQuery('[data-prevent-popups]').length){
        return;
    }

    WPPopups.initialize();
});
